module.exports = __webpack_public_path__ + "static/animation-map-efeba1196e705f6174bba53fc4512cf1.png";